import React from 'react';

import styles from './Discourse.module.scss';

const DiscoursePublishingInfoSection = ({ document }) => {
  const authorProfilePath = document?.author?.path;

  const authorName = document?.author?.name;

  const localeDateString = () => {
    const date = new Date(Date.parse(document?.publishedAt));
    return date.toLocaleDateString();
  };

  const publishingInfoMessagePrefix = !!document?.publishedAt ?
  `Published on ${localeDateString()} by ` :
  `Written by `;

  const shouldDisplayPublishingInfo = authorProfilePath && authorName;

  if (shouldDisplayPublishingInfo) {
    return (
      <div className={styles.publishingInfoSection}>
        <p className={styles.publishingInfo}>
          {publishingInfoMessagePrefix} <a id={styles.author} href={authorProfilePath}>{authorName}</a>
        </p>
      </div>
    );
  }

  return null;
};

export default DiscoursePublishingInfoSection;
